import TomSelect from 'tom-select';
import Swiper from 'swiper';
import SwiperCore, {
  Navigation,
  Pagination,
  Lazy,
  EffectFade,
  Autoplay,
  HashNavigation,
} from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([
  Navigation,
  Pagination,
  Lazy,
  EffectFade,
  Autoplay,
  HashNavigation,
]);

export default class RealizationsMap {
  constructor() {
    this.form = document.querySelector('[data-search-realizations ]');
    this.form_inputs = null;
    this.select_voivodeship = document.querySelector('#wojewodztwo');
    this.voivodeship_maps = document.querySelectorAll('[data-map]');
    this.ajax_url = window.ajax_object.ajax_url;
    this.filters = {
      voivodeship: null,
      industry: null,
      heating_power_from: 0,
      heating_power_to: 9999,
    };
    this.realization_pins = document.querySelectorAll('[data-realization]');
    this.realizations_data = {};
    this.realization_toggle_tooltips_buttons = document.querySelectorAll('[data-realization-toggle-button]');
    this.realization_tooltips = document.querySelectorAll('[data-realization-details]');
    this.details_wrapper = document.querySelector('[data-voivodeship-realizations-details]');
    this.agents = document.querySelectorAll('[data-agent-area]');
    this.mobile_slider = document.querySelectorAll('.js-data-reference-list');
    this.sliders = [];
    this.tom_select = null;
    this.open_tooltip = null;
  }

  init() {
    if (!this.form || !this.voivodeship_maps) {
      return false;
    }

    this.form_inputs = this.form.querySelectorAll('input');

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      // hide accordions
      const accordions = document.querySelectorAll('[data-accordion-button]');
      if(accordions) {
        accordions.forEach((e) => {
            e.parentElement.classList.remove('is-active');
        });
      }

      this.submit();
    })

    // this.tomSelect();
    // this.filtersEvents();
    this.pinsEvents();
    this.realizations_data = this.getRealizationsData();
    this.submitOnChangeInput();
    this.initializeMobileSliders();
  }

  findHiddenPins() {
    this.realization_pins.forEach((item) => {
      if (item.classList.contains('hidden')) {
        item.classList.remove('swiper-slide');
      } else {
        if (!item.classList.contains('swiper-slide')) {
          item.classList.add('swiper-slide');
        }
      }
    })
  }

  resetSliderStyles() {
    this.realization_pins.forEach((item) => {
      if (item.classList.contains('swiper-slide')) {
        item.classList.remove('swiper-slide');
      }
    })

    document.querySelectorAll('.front-realizations-map .swiper-wrapper').forEach((item) => {
      item.classList.remove('swiper-wrapper');
    })

    this.mobile_slider.forEach((item) => {
      item.classList.remove('swiper');
    })

  }

  initializeMobileSliders() {
    if (!this.mobile_slider || window.innerWidth > 768) {
      this.resetSliderStyles();
      return false;
    }

    this.findHiddenPins();

    this.mobile_slider.forEach((elem, index) => {
      const html_id = elem.id;
      if (!html_id) {
        return;
      }

      this.sliders[index] = this.renderSingleSlider(html_id);
    })
  }

  renderSingleSlider(html_id) {
    const id = '#' + html_id;
    const args = {
      slidesPerView: "auto",
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    };
    let slider = new Swiper(id, args);
  }

  submitOnChangeInput() {
    this.form_inputs.forEach((element) => {
      ['change', 'keyup'].forEach((event) => {
        element.addEventListener(event, (e) => {
          e.preventDefault();
          this.submit();
        });
      });
    })
  }

  submit() {
    const industries_checkboxes = this.form.querySelectorAll('input[name="sector"]:checked');
    const industries = [];
    for (var i = 0; i < industries_checkboxes.length; i++) {
      industries.push(parseInt(industries_checkboxes[i].value))
    }

    const voivodeships_checkboxes = this.form.querySelectorAll('input[name="wojewodztwo"]:checked');
    const voivodeships = [];
    for (var i = 0; i < voivodeships_checkboxes.length; i++) {
      voivodeships.push(voivodeships_checkboxes[i].value);
    }

    const heating_power_from_input = parseInt(this.form.querySelector('input[name="heating_power_from"]').value);
    const heating_power_to_input = parseInt(this.form.querySelector('input[name="heating_power_to"]').value);

    const heating_power_from = heating_power_from_input ? heating_power_from_input : this.filters.heating_power_from;
    const heating_power_to = heating_power_to_input ? heating_power_to_input : this.filters.heating_power_to;

    this.updateFilterState('industry', industries);
    this.updateFilterState('voivodeship', voivodeships);
    this.updateFilterState('heating_power_from', heating_power_from);
    this.updateFilterState('heating_power_to', heating_power_to);

    this.filterPins();
    this.initializeMobileSliders();
  }

  filterPins() {

    this.showVoivodeshipMap();

    let filtering_industries = this.filters.industry;
    const keys = Object.keys(this.realizations_data);
    keys.forEach((key, index) => {
      let sector = this.realizations_data[key]['sector'];
      let heating_power = parseInt(this.realizations_data[key]['heating']);
      let show_pin = true;

      if (filtering_industries.length > 0) {
        if (!filtering_industries.includes(sector)) {
          show_pin = false;
        }
      }

      heating_power = (isNaN(heating_power)) ? 0 : heating_power;
      const from = parseInt(this.filters.heating_power_from);
      const to = parseInt(this.filters.heating_power_to);

      if (!(heating_power >= from)) {
        show_pin = false;
      }

      if (!(heating_power <= to)) {
        show_pin = false;
      }

      if (show_pin) {
        this.realization_pins[index].classList.remove('hidden');
      } else {
        this.realization_pins[index].classList.add('hidden');
        this.togglePinElement(index, true);
      }

    });

  }


  getRealizationsData() {
    let temp_object = {};
    this.realization_pins.forEach((item) => {
      let data = JSON.parse(item.getAttribute('data-realization'));
      temp_object['realization-' + data.id] = data;
    })

    return temp_object;
  }

  filtersEvents() {
    this.select_voivodeship.addEventListener('change', (event) => {
      this.updateFilterState('voivodeship', event.target.value);
      this.showMap(event.target.value);
      this.showAgents(event.target.value);

      this.togglePinElement(this.open_tooltip, true);
    })
  }


  pinsEvents() {
    this.realization_toggle_tooltips_buttons.forEach((button, index) => {
      button.addEventListener('click', (e) => {
        let v = button.parentElement.parentElement.dataset.realizationVoivodeship;
        console.log('v1');
        this.showAgents(v)
        this.togglePinElement(index);
      })
    });
  }

  hideAllSmallPinsTooltips() {
    this.activeElementOfList(this.realization_tooltips, index, hide);
  }

  togglePinElement(index, hide = false) {
    this.activeElementOfList(this.realization_toggle_tooltips_buttons, index, hide);
    this.activeElementOfList(this.realization_tooltips, index, hide);
    this.activeElementOfList(this.realization_pins, index, hide);
  }

  activeElementOfList(list, index, hide = false) {
    list.forEach((item, item_index) => {
      if (hide) {
        item.classList.remove('is-active');
        this.open_tooltip = null;
      } else if (item_index != index) {
        item.classList.remove('is-active');
        this.open_tooltip = null;
      } else if (item_index == index && item.classList.contains('is-active')) {
        item.classList.remove('is-active');
        this.open_tooltip = null;
      } else {
        item.classList.add('is-active');
        this.open_tooltip = item;
      }
    });
  }


  // tomSelect() {
  //   this.tom_select = new TomSelect("#wojewodztwo", {
  //     create: false,
  //     // sortField: {
  //     //   field: "text",
  //     //   direction: "asc",
  //     // },
  //     render: {
  //       no_results: function (data, escape) {
  //         return '<div class="no-results">Nie znaleziono "' + escape(data.input) + '"</div>';
  //       },
  //     },
  //   });
  // }

  updateFilterState(filter_name, filter_value) {
    this.filters[filter_name] = filter_value;
    if(filter_name === 'voivodeship')
    {
      this.showAgents(filter_value)
    }
    return this.filters;
  }

  showVoivodeshipMap() {

    let filtering = this.filters.voivodeship;
    // console.log(filtering);
    this.voivodeship_maps.forEach((v) => {
      let voivodeship = v.dataset.map;
      if (filtering.find((el) => el === voivodeship)) {
        v.style.display = 'block';
      } else {
        v.style.display = 'none';
      }
    })
  }


  // showMap(active_voivodeship) {
  //   this.voivodeship_maps.forEach((v) => {
  //     let voivodeship = v.dataset.map;
  //     if (voivodeship == active_voivodeship) {
  //       v.style.display = 'block';
  //     } else {
  //       v.style.display = 'none';
  //     }
  //   })
  // }

  showAgents(active_voivodeship) {

    if(active_voivodeship === 'default') {
      document.querySelector('[data-agents-title]').style.display = 'none';
      this.agents.forEach((v) => {
        v.style.display = 'none';
      })
      return;
    }

    this.agents.forEach((v) => {
      let voivodeship = v.dataset.agentArea;
      if (voivodeship == active_voivodeship) {
        v.style.display = 'block';
      } else {
        v.style.display = 'none';
      }
    })

    document.querySelector('[data-agents-title]').style.display = 'block';
  }
}

